import { normalizePage, normalizeProduct } from '../normalizers'
import { buildCanonicalProductPath } from '../routing'
import { fetchJson } from '../ssr'
import type { Route } from '../types'
import type { SeoRouteLoadContext } from './types'
import { fetchNormalizedCategories } from './loadersShared'
import { dedupeSeoAlternates } from '../seo/localePolicy'

export const loadProductSeoContext = async ({
  route,
  apiBase,
  context,
}: {
  route: Extract<Route, { mode: 'product' }>
  apiBase: string
  context: SeoRouteLoadContext
}) => {
  const endpoint = route.previewId
    ? `${apiBase}/catalog/products/${encodeURIComponent(route.previewId)}`
    : route.publicCode
    ? `${apiBase}/catalog/products/code/${encodeURIComponent(route.publicCode)}`
    : `${apiBase}/catalog/products/${encodeURIComponent(route.slug)}`
  const productResponse = await fetchJson(endpoint)
  if (!productResponse.ok) return

  context.productData = normalizeProduct((productResponse.data?.product ?? {}) as Record<string, unknown>)
  const categories = await fetchNormalizedCategories(apiBase)
  context.canonicalPath = buildCanonicalProductPath(context.productData, categories)
}

export const loadPreviewSeoContext = async ({
  route,
  apiBase,
  context,
}: {
  route: Extract<Route, { mode: 'preview' }>
  apiBase: string
  context: SeoRouteLoadContext
}) => {
  const pageResponse = await fetchJson(`${apiBase}/pages/${encodeURIComponent(route.id)}/preview`)
  if (!pageResponse.ok) return

  context.pageData = normalizePage((pageResponse.data?.page ?? {}) as Record<string, unknown>)
  context.pageData.seoCanonicalLocale = context.pageData.locale
  context.pageData.seoAlternates = dedupeSeoAlternates(
    [{ locale: context.pageData.locale, path: `/preview/${encodeURIComponent(route.id)}` }],
    `/preview/${encodeURIComponent(route.id)}`,
  )
  context.canonicalPath = `/preview/${encodeURIComponent(route.id)}`
}
